module.exports = __webpack_public_path__ + "static/media/zocalo8.bd62a786.jpg";